
<div class="spinner">
    <img class="loader-image" src="../../../assets/icons/loader.gif">
</div>
